import {
  GutterIntervalController,
  LegacyGroupingController,
  RouteGroupSelectorController,
  RouteSelectorController,
  ScaleController,
} from '@/features/calendar/controllers'
import { Box, List, ListItem } from '@mui/material'

export const PlanningMainMenu = () => {
  return (
    <Box sx={{ padding: '5px' }}>
      <LegacyGroupingController />
      <ScaleController />
      <GutterIntervalController />
      <Box sx={{ padding: '5px' }}>
        <RouteGroupSelectorController />
        <RouteSelectorController />
      </Box>
    </Box>
  )
}

export const PlanningMainMenuList = () => {
  return (
    <List>
      <ListItem disablePadding>
        <LegacyGroupingController />
      </ListItem>
      <ListItem disablePadding>
        <ScaleController />
      </ListItem>
      <ListItem disablePadding>
        <GutterIntervalController />
      </ListItem>
      <ListItem disablePadding>
        <RouteGroupSelectorController />
      </ListItem>
      <ListItem disablePadding>
        <RouteSelectorController />
      </ListItem>
    </List>
  )
}
